import get from 'lodash/get'
import snakeCase from 'lodash/snakeCase'
import pickBy from 'lodash/pickBy'
import identity from 'lodash/identity'

const stationFormat = (station) => {
  if (typeof station === 'object') {
    return station.crs_code
  }
  return station
}

const ensureArray = (value) => {
  if (typeof value === 'string') {
    return [value]
  }
  return value
}

export default function journeyLegSearchParams(form) {
  if (form === null) {
    return []
  }

  const journeyLegParams = {
    booking_ref_eq: form.booking_ref_eq,
    reservation_ref_eq: form.reservation_ref_eq,
    reservation_headcode_eq: form.reservation_headcode_eq,
    train_operator: form.train_operator,
    status_eq: snakeCase(form.status_eq),
    customer_ref_eq: form.customer_ref_eq,
    customer_name: form.customer_name,
    customer_email_eq: form.customer_email_eq,
    customer_contact_number_eq: form.customer_contact_number_eq,
    customer_postcode_eq: form.customer_postcode_eq,
    board_station_code_eq: stationFormat(get(form, 'board_station_code_eq')),
    alight_station_code_eq: stationFormat(get(form, 'alight_station_code_eq')),
    station_code_eq: stationFormat(get(form, 'station_code_eq')),
    date_from: form.date_from,
    date_to: form.date_to,
    data_source_eq: form.data_source_eq,
    page: form.page,
    per_page: form.per_page,

    ...(form.assistance_status_in?.length > 0
      ? { assistance_status_in: ensureArray(form?.assistance_status_in)?.filter(Boolean) }
      : {}),
    ...(form.assignment_status_in?.length > 0
      ? { assignment_status_in: ensureArray(form?.assignment_status_in)?.filter(Boolean) }
      : {}),
  }

  return pickBy(journeyLegParams, identity)
}
